import { isEqual } from "lodash";
import CustomSelect from "../../../components/forms/CustomSelect";
import CustomTextDelayInput from "../../../components/forms/CustomTextDelayInput";
import DateField from "../../../components/forms/DateField";
import { usePrivilege } from "../../../components/priviledge/PriviledgeProvider";
import useCompanies from "../../../hooks/api-calls/useCompanies";
import useProviders from "../../../hooks/api-calls/useProviders";


interface ProvidersInvoiceFilters {
    updateFilters: (filters: any) => void;
    filters: any;
}


const ProvidersInvoiceFilters = ({ updateFilters, filters }: ProvidersInvoiceFilters) => {

    // HOOKS

    const { getProvidersList } = useProviders();
    const { userCan } = usePrivilege();
    const { getCompaniesList } = useCompanies();

    // RENDER

    return (
        <>
            <CustomTextDelayInput
                id="number"
                label="Nº de Factura"
                placeholder="Buscar por nº de factura"
                filters={filters}
                updateFilters={updateFilters}
            />

            <CustomSelect
                required
                isSearchable
                id={"provider"}
                label="Proveedor"
                value={filters.filter_filters?.provider ? { value: filters.filter_filters?.provider, label: getProvidersList()?.find((g: any) => g.value === filters.filter_filters?.provider)?.label } : null}
                options={getProvidersList()}
                onChange={
                    (e: any) => {
                        if (!e || e.value === null) updateFilters({ provider: null })
                        else updateFilters({ provider: e.value })
                    }
                }
                isClearable
            />

            <DateField
                isClearable
                className="w-full"
                label="Fecha de facturación"
                placeholderText="Selecciona las fechas"
                selectedDateField={filters.filter_filters?.between_dates?.type || "invoiceDate"}
                dateTypesOptions={[
                    { value: "invoiceDate", label: "Fecha de facturación" },
                ]}
                startDate={filters.filter_filters?.between_dates?.start_date ? new Date(filters.filter_filters.between_dates.startDate) : null}
                endDate={filters.filter_filters?.between_dates?.end_date ? new Date(filters.filter_filters.between_dates.endDate) : null}
                onChange={(date: any) => {
                    const filters_between_dates = filters.filter_filters?.between_dates;
                    const between_dates = date ? { startDate: date[0], endDate: date[1] } : null;

                    if (between_dates && !isEqual(filters_between_dates, between_dates)) {
                        updateFilters({ between_dates: { startDate: date[0], endDate: date[1], type: date[2] } });
                    } else if (!between_dates && filters_between_dates) {
                        updateFilters({ between_dates: null });
                    }
                }}
            />

            {userCan('list', 'company') && (
                <CustomSelect
                    isSearchable
                    id="company"
                    label="Compañía"
                    options={getCompaniesList()}
                    value={getCompaniesList().find((item: any) => item.value === filters.filter_filters?.company) ?? { label: 'Todas', value: 'null' }}
                    onChange={(e: any) => {
                        if (e.value === 'null') {
                            updateFilters({ company: null });
                            return;
                        }
                        updateFilters({ company: e.value });
                    }}
                />
            )}

            <CustomSelect
                required
                isSearchable
                id={"is_paid"}
                label="Estado"
                value={filters.filter_filters?.is_paid !== undefined ?
                    {
                        value: filters.filter_filters.is_paid,
                        label: filters.filter_filters.is_paid ? "Pagada" : "No pagada"
                    } : null
                }
                options={[
                    { label: "Pagada", value: true },
                    { label: "No pagada", value: false },
                ]}
                onChange={
                    (e: any) => {
                        updateFilters({ is_paid: e.value })
                    }
                }
            />

        </>
    );

}

export default ProvidersInvoiceFilters;